export default __webpack_public_path__ + "5403754f83289400f4ebba1895f58498.svg";